import { Heading } from '@dittolive/anvil'
import graphql from 'babel-plugin-relay/macro'
import { Container } from 'components/layout'
import { useFragment } from 'react-relay/hooks'

import { UserManagementHeader_userInfo$key } from './__generated__/UserManagementHeader_userInfo.graphql'

const userInfoFragment = graphql`
  fragment UserManagementHeader_userInfo on User {
    firstName
    lastName
  }
`

type Props = {
  user: UserManagementHeader_userInfo$key
}

export default function UserManagementHeader({ user }: Props) {
  const data = useFragment(userInfoFragment, user)

  return (
    <div className="bg-background h-24">
      <Container className="flex h-full flex-col justify-center py-4">
        <Heading level={1} data-testid="userTenantHeader">
          {data.firstName} {data.lastName}
        </Heading>
      </Container>
    </div>
  )
}
